export const GROWTH_VERSION = 'first-value-v1';
export const PURPOSE_OPTIONS = [
  { value: 'coursework', label: 'Finish homework or a class presentation' },
  { value: 'work_presentation', label: 'Create visuals for a work, sales, or client presentation/report' },
  { value: 'data_analysis', label: 'Analyze data to answer a specific question' },
  { value: 'monitoring', label: 'Keep track of metrics that change over time' },
  { value: 'other', label: 'Something else' },
  { value: 'unsure', label: 'Not sure yet' },
] as const;
export const ISSUE_OPTIONS = [
  { value: 'missing_visual', label: 'Missing visual' },
  { value: 'readability', label: 'Hard to read' },
  { value: 'incorrect_numbers', label: 'Wrong numbers' },
  { value: 'wrong_format', label: 'Wrong format' },
  { value: 'download', label: 'Download problem' },
  { value: 'slow', label: 'Too slow' },
  { value: 'other', label: 'Something else' },
] as const;
export const GUIDED_STARTS = [
  {
    id: 'comparison',
    label: 'Compare options',
    prompt: 'Create a comparison visual using only these facts.\nOptions and values:\n\nWhat I want to compare:\n',
  },
  {
    id: 'before_after',
    label: 'Show before and after',
    prompt:
      'Create a before-and-after chart using only these values.\nMetric | Before | After\n\nLabel any assumptions clearly.\n',
  },
  {
    id: 'timeline',
    label: 'Create a timeline',
    prompt: 'Create a timeline using these steps and dates. Do not invent dates.\nStep | Start | End\n\n',
  },
] as const;
export type GrowthPhase = 'off' | 'purpose' | 'guided' | 'extra_turn' | 'one_time_export';
export type GrowthContext = { phase: GrowthPhase; variant: string; version: string; purposeAnswered: boolean };

// Cached images may render before a sibling registers its event listener.
const renderedArtifacts = new Map<string, string>();
export function announceArtifactRendered(artifactId?: string, chatId?: string) {
  if (typeof window === 'undefined' || !artifactId) return;
  renderedArtifacts.set(artifactId, chatId || '');
  if (renderedArtifacts.size > 200) renderedArtifacts.delete(renderedArtifacts.keys().next().value!);
  window.dispatchEvent(new CustomEvent('plotsalot-artifact-rendered', { detail: { chatId, artifactId } }));
}
export function hasRenderedArtifact(artifactId?: string, chatId?: string) {
  return artifactId ? renderedArtifacts.has(artifactId) : !!chatId && [...renderedArtifacts.values()].includes(chatId);
}

export function safeAnalyticsProperties(properties: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(properties).filter(
      ([key, value]) =>
        ![
          'error_message',
          'file_name',
          'pending_pdf_names',
          'filename',
          'chart_title',
          'stack',
          'prompt',
          'message',
          'email',
          'name',
        ].includes(key) &&
        value !== undefined &&
        (value === null || ['boolean', 'number', 'string'].includes(typeof value)) &&
        !(typeof value === 'string' && (/https?:\/\//i.test(value) || value.length > 250))
    )
  );
}
